import { render, staticRenderFns } from "./PprConfig.vue?vue&type=template&id=1f0ef06a&scoped=true"
import script from "./PprConfig.vue?vue&type=script&lang=js"
export * from "./PprConfig.vue?vue&type=script&lang=js"
import style0 from "./PprConfig.vue?vue&type=style&index=0&id=1f0ef06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ef06a",
  null
  
)

export default component.exports